import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosService from '../../../utility/axiosService/axiosService'
import { API_ENDPOINT } from '../../../utility'
import { toast } from "react-toastify"

export const getProductList = createAsyncThunk(
    'users/getProductList',
    async (data) => {

        if (data == 'all') {
            return await axiosService.get(`${API_ENDPOINT}/admin/product`,{
                params: {
                    limit: data.limit || 10,
                    page: data.page,
                    search: data.search || null,
                    product_line_id: data.product_line_id.value || null,
                    provider_id: data.provider_id.value || null,
                    platform: data.platform.value || null
                }
            }).then((res) => {
                return res.data;
            });
        } else {
            return await axiosService.get(`${API_ENDPOINT}/admin/product`, {
                params: (data ? {
                    limit: data.limit || 10,
                    page: data.page,
                    search: data.search || null,
                    product_line_id: data.product_line_id.value || null,
                    provider_id: data.provider_id.value || null,
                    platform: data.platform.value || null
                } : {
                    page: 1,
                    search: ""
                })
            }).then((res) => {
                return res.data;
            });
        }
    }
);

export const getQuestion = createAsyncThunk(
    'users/getQuestion',
    async (data) => {
        return await axiosService.get(`${API_ENDPOINT}/admin/question`,{
        }).then((res) => {
            console.log(res.data)
            return res.data;
        });
    }
);

export const updateProduct = createAsyncThunk('users/updateProduct', async (data) => {  
    const dataCheck = data.Questions;
    var check = dataCheck.some(obj => obj.hasOwnProperty(['id']));
            if ( check === true){
                const updateData = {
                    image_1: data.image_1,
                    status: data.status,
                    question_list: data.Questions.map(x => x.id) 
                };
                
                return await axiosService
                    .put(`${API_ENDPOINT}/admin/product/${data.product_code}`, updateData)
                    .then((res) => {
                        return res;
                    })
                    .catch((err) => console.log(err));
        
            }else {
                const updateData = {
                    image_1: data.image_1,
                    status: data.status,
                    question_list: data.Questions
                };
                
                return await axiosService
                    .put(`${API_ENDPOINT}/admin/product/${data.product_code}`, updateData)
                    .then((res) => {
                        return res;
                    })
                    .catch((err) => console.log(err));
        
            }


});


export const getProductListIfExistTrans = createAsyncThunk(
    'users/getProductListIfExistTrans',
    async () => {
        return await axiosService.get(`${API_ENDPOINT}/admin/product-transaction-exist`, {
            params: {
                limit: 1000
            }
        }).then((res) => {
            return res.data;
        });
    }
)

const productSlice = createSlice({
    name: 'product',
    initialState: {
        loading: false,
        modal: false,
        data: [],
        dataQuestion: [],
        error: null,
        total_page: 0,
        filterValues: {
        limit: 10,
        page: 1,
        product_line_id: "",
        provider_id: "",
        platform: "",
        search: ""
        },
        dataFilter: {
            keyword: "",
            page: 1,
            limit: 10
        },
        dataExistTrans: [],
    },
    reducers: {
        getModal: (state, { payload }) => {
            state.modal = true;
            state.dataDetails = payload;
        },
        removeModal: (state) => {
            state.dataDetails = null;
            state.modal = false;
        },
        searchTextFieldSlice: (state, { payload }) => {
            state.keyword = payload.data;
        },
        paginationHandleSlice: (state, { payload }) => {
            state.page = payload.data;
        },
        filterData: (state, { payload }) => {
            console.log(payload);
            state.filterValues.page = payload.page || state.filterValues.page;
        }
    },
    extraReducers: {
        [getProductList.pending]: (state) => {
            state.loading = true;
        },
        [getProductList.fulfilled]: (state, { payload }) => {
            state.data = payload.data.result;
            state.total_page = payload.data.total_page;
            state.loading = false;
        },
        [getQuestion.pending]: (state) => {
            state.loading = true;
        },
        [getQuestion.fulfilled]: (state, { payload }) => {
            state.dataQuestion = payload.data.result;
            state.loading = false;
        },
        [getProductListIfExistTrans.pending]: (state) => {
            state.loading = true;
        },
        [getProductListIfExistTrans.fulfilled]: (state, { payload }) => {
            state.dataExistTrans = payload.data.result;
            state.loading = false;
        },
        [updateProduct.fulfilled]:  (state, { payload }) => {
            if  (payload.data.code === 0) {
                  toast.success('Cập nhật dữ liệu thành công !');
                //   setTimeout(function(){window.location.reload()}, 3000);
            } else {
                toast.error(`Cập nhật dữ liệu thất bại: ${payload.data.mess}`);
            }
            // const index = state.dataOrganizations.findIndex(_item => _item.id === payload.data.data.id);
            // state.dataOrganizations[index] = payload.data.data;
        },
        [updateProduct.rejected]: (state, action) => {
            state.error = action.payload;
        }
    }
});

export const { getModal, removeModal ,filterData} = productSlice.actions;

export default productSlice.reducer;